// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2qUaK","selected":"Chip_selected__2PzvE"};